<template>
    <div class="container">
      <b-modal
        content-class="md_modal_content"
        hide-header-close
        hide-footer
        hide-header
        no-close-on-backdrop
        size="xl"
        @show="onShow"
        id="send_noti">
        <div class="container">
          <div class="md_modal_header">
            <div class="container md_modal_header_wrapper h-100" style="padding: 0;">
              <h6 style="text-align: center">{{$t('more.send_noti')}}</h6>
            </div>
          </div>
          <div class="md_modal_body">
            <b-form-input :placeholder="$t('community.title_placeholder')"></b-form-input>
            <div class="align-horizontal mt-2">
              <b-form-input v-model="siteName" :value="siteName" disabled style="flex: 7;"></b-form-input>
              <b-button class="md_btn_primary md_txt_md ml-2" variant="primary" style="flex: 3;">{{$t('more.link_my_site')}}</b-button>
            </div>
            <div class="align-horizontal mt-2">
              <b-form-input v-model="address" :value="address" disabled style="flex: 7;"></b-form-input>
              <b-button class="md_btn_primary md_txt_md ml-2" variant="primary" style="flex: 3;">{{$t('more.address_search')}}</b-button>
            </div>
            <div class="align-horizontal mt-2">
              <b-form-input v-model="name1" class="mr-2" style="flex: 1;" placeholder="홍길동"></b-form-input>
              <b-form-input v-model="phone1" class="mr-2" style="flex: 2;" placeholder="010-0000-0000"></b-form-input>
              <b-form-input v-model="name2" class="mr-2" style="flex: 1;" placeholder="홍길동"></b-form-input>
              <b-form-input v-model="phone2" style="flex: 2;" placeholder="010-0000-0000"></b-form-input>
            </div>
            <b-form-textarea
              :placeholder="$t('community.content_placeholder')"
              class="mt-3" rows="20"></b-form-textarea>
            <div class="align-vertical mt-3">
              <b-button class="btn_browser md_btn_secondary md_txt_md">{{$t('community.attachments')}}</b-button>
              <b-form-input
                class="mt-2"
                v-on:click="removeAttach(a)"
                v-bind:key="a"
                v-for="a in attachs" :value="a"></b-form-input>
            </div>
            <div class="align-horizontal mt-3" style="justify-content: space-between">
              <div class="made_guide_txt">
                {{$t('community.made_guide')}}
              </div>
              <b-button
                @click="showModalPush"
                variant="danger" class="md-btn md_btn_danger md_btn_icon md_txt_md">
                <b-img
                  height="30px"
                  width="30px"
                  :src="push ? require('../../../../assets/image/ic_check_red_on@2x.png')
                : require('../../../../assets/image/ic_check_red_off@2x.png')"></b-img>
                <span class="ml-1">{{$t('community.push')}}</span>
              </b-button>
              <b-button
                @click="showModalMadePlus"
                variant="danger" class="md_btn md_btn_danger md_btn_icon md_txt_md">
                <b-img
                  height="30px"
                  width="30px"
                  :src="made ? require('../../../../assets/image/ic_check_red_on@2x.png')
                : require('../../../../assets/image/ic_check_red_off@2x.png')"></b-img>
                <span class="ml-1">{{$t('community.made_plus')}}</span>
              </b-button>
            </div>
            <div class="w-100 mt-2 mb-3" style="text-align: right">
              <span
                v-b-tooltip.html="{customClass: 'md-tooltip', variant: 'secondary', title: $t('community.writing_limit_desc')}"
                class="md_link_text">
                {{$t('more.noti_tooltip')}}
              </span>
            </div>
          </div>
          <div class="md_modal_footer">
            <div class="container md_modal_footer_wrapper h-100" style="padding: 0">
              <b-button-group class="w-100 h-100">
                <b-button
                  @click="hideModal"
                  class="no_border_radius md_btn_light">{{$t('common.cancel')}}</b-button>
                <b-button
                  @click="completeWriteNoti"
                  class="no_border_radius md_btn_primary">{{$t('common.complete1')}}</b-button>
              </b-button-group>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        hide-header-close
        centered
        hide-footer
        hide-header
        content-class="md_inner_modal"
        id="modal-push">
        <div class="container align-vertical v_center">
          <h5 class="mt-3">
            {{$t('community.push_title')}}
          </h5>
          <div class="mt-3" style="text-align: center" v-html="$t('community.push_content')"></div>
          <div class="align-horizontal h_center w-100 mt-5 mb-3">
            <b-button
              @click="$bvModal.hide('modal-push')"
              variant="light" class="md_btn md_btn_light mr-4">{{$t('common.cancel1')}}</b-button>
            <b-button
              @click="useMadePlusMode"
              variant="primary" class="md_btn md_btn_primary">{{$t('common.ok')}}</b-button>
          </div>
        </div>
      </b-modal>

      <b-modal
        hide-header-close
        centered
        hide-footer
        hide-header
        content-class="md_inner_modal"
        id="modal-made-plus">
        <div class="container align-vertical v_center">
          <h5 class="mt-3">
            {{$t('community.made_title')}}
          </h5>
          <div class="mt-3" style="text-align: center" v-html="$t('community.made_content')"></div>
          <div class="align-horizontal h_center w-100 mt-5 mb-3">
            <b-button
              @click="$bvModal.hide('modal-made-plus')"
              variant="light" class="md_btn md_btn_light mr-4">{{$t('common.cancel1')}}</b-button>
            <b-button
              @click="usePushMode"
              variant="primary" class="md_btn md_btn_primary">{{$t('common.ok')}}</b-button>
          </div>
        </div>
      </b-modal>
    </div>
</template>

<script>
    export default {
        name: "SendNotification",
        data() {
            return {
                siteName: "site name",
                address: "address",
                name1: "",
                phone1: "",
                name2: "",
                phone2: "",
                attachs: [],
                made: false,
                made1: true,
                push: false,
            }
        },
      inject: ['eventBus'],
      mounted() {
            if (this.$route.path == '/notify/send')
            {
                this.$bvModal.show('send_noti');
            }
        },
        methods: {
          onShow(){
            this.eventBus.$emit('setModal', this);
            window.history.pushState('forward', null, );
          },
            hideModal() {
                this.$router.back();
            },
            completeWriteNoti() {
                this.$bvModal.hide('send_noti');
            },
            removeAttach(attach) {
                let index = this.attachs.findIndex(a => a == attach);
                this.attachs.splice(index, 1)
            },
            showModalPush() {
                this.$bvModal.show('modal-push')
            },
            showModalMadePlus() {
                this.$bvModal.show('modal-made-plus')
            },
            usePushMode() {
                this.push = true;
                this.$bvModal.hide('modal-push');
            },
            useMadePlusMode() {
                this.made = true;
                this.$bvModal.hide('modal-made');
            }
        }
    }
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/vars";
  .vertical_align {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .btn_browser {
    width: fit-content;
  }
  .made_guide_txt {
    color:#cf0000;
    font-size: $fs_12;
    max-width: 45%;
    text-align: center;
    padding: 0 10px;
  }
  .md_btn_icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px;
  }
  .md_link_text {
    font-size: 12px;
    text-decoration: underline;
    color: #457fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/contents/main/notify/SendNotification.vue